import { useState } from 'react';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import ShowChart from '@material-ui/icons/ShowChart';

import UnitOptimizerHistoryPopup from 'app/admin/optimizationPipeline/component/pipeline/UnitOptimizerHistoryPopup';

function ShowChartButton(props) {
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <>
            {props.form ? (
                <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item?.id} onClick={(e) => { e.preventDefault(); setOpenDialog(true); }} startIcon={<ShowChart className='hidden sm:flex' />}>
                    Show Chart
                </Button>
            ) : (
                <TableCell className='w-auto text-center' padding='none'>
                    <Tooltip title='Show Chart'>
                        <IconButton onClick={(e) => { e.preventDefault(); setOpenDialog(true); }} disabled={!props.item?.id}>
                            <ShowChart fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </TableCell>
            )}

            {openDialog && (<UnitOptimizerHistoryPopup id={props.item?.id} onClose={() => setOpenDialog(false)} title='State' />)}
        </>
    );
}

export default ShowChartButton;
